import React, { useState, useEffect } from 'react';
import { Box, Typography, Button } from '@mui/material';

const GA_ID = 'G-1C45XF5DS1';
const CONSENT_KEY = 'cookieConsent';

const loadGA = () => {
  if (window._gaLoaded) return;
  window._gaLoaded = true;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag('js', new Date());
  window.gtag('config', GA_ID);
};

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(CONSENT_KEY);
    if (stored === 'accepted') {
      loadGA();
    } else if (!stored) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(CONSENT_KEY, 'accepted');
    loadGA();
    setVisible(false);
  };

  const handleDeny = () => {
    localStorage.setItem(CONSENT_KEY, 'denied');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1400,
        backgroundColor: '#111111',
        borderTop: '1px solid #2a2a2a',
        px: { xs: 3, md: 6 },
        py: { xs: 3, md: 2.5 },
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: { xs: 'flex-start', sm: 'center' },
        gap: { xs: 2.5, sm: 4 },
      }}
    >
      <Typography
        sx={{
          fontFamily: 'Outfit',
          fontWeight: 300,
          fontSize: '0.9rem',
          color: 'rgba(255,255,255,0.7)',
          flex: 1,
          lineHeight: 1.6,
        }}
      >
        We'd love to understand how you're using our site so we can keep improving it.
        Do you mind if we use analytics cookies to help us do that?{' '}
        <Typography
          component="a"
          href="/privacy-policy"
          sx={{
            fontFamily: 'Outfit',
            fontWeight: 400,
            fontSize: '0.9rem',
            color: '#004D40',
            textDecoration: 'underline',
            '&:hover': { color: '#00695C' },
          }}
        >
          Privacy Policy
        </Typography>
      </Typography>

      <Box sx={{ display: 'flex', gap: 2, flexShrink: 0 }}>
        <Button
          onClick={handleDeny}
          variant="outlined"
          sx={{
            fontFamily: 'Outfit',
            fontWeight: 500,
            fontSize: '0.875rem',
            color: 'rgba(255,255,255,0.6)',
            borderColor: 'rgba(255,255,255,0.2)',
            borderRadius: 1,
            px: 3,
            py: 1,
            textTransform: 'none',
            '&:hover': {
              borderColor: 'rgba(255,255,255,0.4)',
              backgroundColor: 'rgba(255,255,255,0.05)',
            },
          }}
        >
          Deny
        </Button>
        <Button
          onClick={handleAccept}
          variant="contained"
          sx={{
            fontFamily: 'Outfit',
            fontWeight: 600,
            fontSize: '0.875rem',
            backgroundColor: '#004D40',
            color: '#ffffff',
            borderRadius: 1,
            px: 3,
            py: 1,
            textTransform: 'none',
            '&:hover': { backgroundColor: '#00695C' },
          }}
        >
          Accept
        </Button>
      </Box>
    </Box>
  );
};

export default CookieBanner;
